// flatten one level deep
const shallowFlatten = <T>(xs: Array<Array<T> | T>): Array<T> => xs.reduce<Array<T>>((acc, x) => acc.concat(x), [])

export default shallowFlatten
